import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles((theme) => ({
  fieldLabel: {
    ...theme.typography.caption,
    color: theme.palette.text.secondary,
    fontWeight: 600,
    textTransform: 'none',
    lineHeight: 1.4,
  },
  fieldValue: {
    ...theme.typography.body2,
    color: theme.palette.text.primary,
    fontWeight: 500,
    lineHeight: 1.4,
    wordBreak: 'break-word',
  },
}))

export default useStyles
